export default function (element: HTMLDetailsElement): () => void {
  const handleClick = (e: MouseEvent): void => {
    const target = e.target as HTMLElement

    if (!element.contains(target)) {
      element.removeAttribute('open')
    }
  }

  document.body.addEventListener('click', handleClick)
  return () => document.body.removeEventListener('click', handleClick)
}
